import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { QueryStatsRounded } from '@mui/icons-material';

type ActionResponse = {
    items?: Array<Record<string, unknown>>;
    total?: number | null;
    hasMore?: boolean;
};

export type AndieGetPostInsightDataProps = ActionRenderAi<ActionResponse>;

const AndieGetPostInsightData = (props: AndieGetPostInsightDataProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-post-insight-data.title')}
            icon={<QueryStatsRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-post-insight-data.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-post-insight-data.complete', {
                    value: Array.isArray(result?.items) ? result.items.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetPostInsightData;
